import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import {gql, useLazyQuery} from "@apollo/client/index";
import NextCar from "./NextCar";
import Box from "@material-ui/core/Box/Box";
import BuyNow from "./BuyNow";
import * as ReactGA from "react-ga";
import useInitialOffer from "./UseInitialOffer";
import ContactsForm from "../../Customer/ContactsForm";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            borderRadius: 0,
            boxShadow: 'none'
        },
        priceBlock: {
            width: '100%'
        },
        blockInfo: {
            width: '50%'
        },
        offerInput: {
            maxWidth: 120,
        },
        offerInputMobile: {
            width: 105,
            marginRight: 10,
        },
        baseRoot: {
            borderRadius: 0
        },
        input: {
            paddingTop: 14,
            paddingBottom: 11,
            fontWeight: 'bold',
            fontSize: '1.2rem',
            textAlign: 'center',
            ['@media (max-width:360px)']: {
                paddingTop: 12,
                paddingBottom: 8,
                width: 105,
                fontSize: '1.1rem',
            },
            ['@media (max-width:320px)']: {
                paddingTop: 10,
                paddingBottom: 6,
            },
        },
        makeButton: {
            height: 47,
            borderRadius: 0,
            backgroundColor: '#3e4043!important',
            color: '#e7edef!important',
            padding: '0 10px!important',
            marginRight: '20px !important',
        },
        makeButtonMobile: {
            height: 44,
            borderRadius: 0,
            backgroundColor: '#3e4043',
            color: '#e7edef',
            padding: '0 10px',
            marginRight: 4,
            ['@media (max-width:360px)']: {
                height: 30,
                width: 105,
                marginTop: 2,
            },
            ['@media (max-width:320px)']: {
                height: 34,
            },
        },
        youSave: {
            marginTop: 4,
        },
        youSaveValue: {
            color: '#c92b0f',
        },
        listPriceMobile: {
        },
        listPriceInput: {
            border: 'none',
            width: 100
        },
        inputLp: {
            paddingTop: 14,
            paddingBottom: 11,
            fontWeight: 'normal',
            fontSize: '1.2rem'
        },
        mobileLabel: {

        },

        //------ list price input

        lpInputWrap: {
            marginTop: 30,
            width: 120
        },
        lpInputRoot: {
            color: '#000 !important',
            borderRadius: 0
        },
        lpInput: {
            paddingTop: 16,
            paddingBottom: 13,
            fontWeight: 'normal',
            fontSize: '1rem'
        },

        lpFieldset: {
            borderStyle: 'dashed'
        },

        // --- buy now link

        buyNowButton: {
            marginTop: 30,
            marginLeft: 20,
            height: 47,
            width: 135,
            borderRadius: 0,
            backgroundColor: '#fff',
            color: 'darkblue',
            '&:hover': {
                background: "#fff",
            },
        },

        //--next car
         nextCarRoot: {
            position: 'relative',

         },
        tile: {
            maxWidth: 150,
            position: 'absolute',
            right: 0
        },
        tileMini: {
            maxWidth: 100,
            position: 'absolute',
            right: 0
        },
        tileMobile: {
            maxWidth: 130,
            position: 'absolute',
            right: 0
        },
    }
});

const SEND_REQUEST = gql`
  query($sn:String, $name:String, $email:String, $phone:String, $discount: Int) {
        contact(contactInput: {sn:$sn, name:$name, email:$email, phone:$phone, discount:$discount}) {
            message
            code
            status
            bookPriceMinorUnits
            extraDiscountMinorUnits
            contactsProvided
        }
  }
`;


export default function Offer(props) {
    const classes = useStyles();
    const useOffer = useInitialOffer();

    const item = props.item;
    const [value, setValue] = React.useState(useOffer.getOffer(item.price));
    const inputRef = React.createRef();
    const isMobile = props.isMobile;
    const isMicro = props.isMicro;

    const [sendRequest, { called, loading, data }] = useLazyQuery(
        SEND_REQUEST
    );

    const onChange = e => {
        ReactGA.event({
            category: 'User',
            action: 'offer_change'
        });
    };

    const onBlur = e => {
        ReactGA.event({
            category: 'User',
            action: 'offer_blur'
        });
        correctValue();
    };

    useEffect(() => {
        props.onOfferChange(value);
    });

    const correctValue = () => {
        let correct = true;
        let newValue = inputRef.current.value;
        newValue = newValue.split('$').join('');
        newValue = newValue.split(',').join('');
        newValue = parseInt(newValue);
        const newValueMinorUnits = newValue * 100;
        let targetValue = value;
        if (value && newValueMinorUnits < value / 2) {
            targetValue = value;
            correct = false;
        } else if (value && newValueMinorUnits > value * 5) {
            targetValue = value;
            correct = false;
        } else if (value !== newValueMinorUnits) {
            setValue(newValueMinorUnits);
            targetValue = newValueMinorUnits;
            props.onOfferChange(newValueMinorUnits);
        }

        if (targetValue) {
            inputRef.current.value = '$' + new Intl.NumberFormat().format(targetValue / 100);
        }

        return correct ? newValueMinorUnits : null;
    };

    const onSubmit = e => {
        e.preventDefault();
        const newValueMinorUnits = correctValue();
        if (newValueMinorUnits) {
            props.onSubmitOffer(e, newValueMinorUnits);

            /*sendRequest({ variables: { sn: item.sn, discount: item.price - newValueMinorUnits } });*/
            ReactGA.event({
                category: 'User',
                action: 'offer_submit'
            });
        }
    };

    if (data) {
        props.onRequestSent(data.contact);
    }

    const form = <form className={classes.root} noValidate autoComplete="off" onSubmit={onSubmit}>
        <TextField
            id="outlined-basic"
            label="Your Offer"
            variant="outlined"
            className={isMobile ? classes.offerInputMobile : classes.offerInput}
            defaultValue={value ? "$"+new Intl.NumberFormat().format(value / 100) : ''}
            onChange={onChange}
            onBlur={onBlur}
            inputRef={inputRef}
            name="offer"
            disabled={loading}
            InputProps={{
                classes: {
                    input: classes.input,
                    root: classes.baseRoot,
                    label: isMobile ? classes.mobileLabel : classes.label,
                }
            }}
        />
        <Button type="submit" variant="contained" size="large" color="primary"
                className={isMobile ? classes.makeButtonMobile : classes.makeButton}
                disabled={loading}>
            {isMobile ? 'Send' : 'Make Offer'}
        </Button>
    </form>;

    return (
        <>
            <div className={classes.nextCarRoot}>
            <Grid container>
                <Grid item >
                    {form}
                    {!item.dealerPrice && props.isMobile ? <Box mt={2}/> : null}
                    {item.dealerPrice ?
                    <Box mt={1}>
                        <Typography style={{fontSize: isMicro ? '.9rem' : '1rem'}}>List Price: <strike>${new Intl.NumberFormat().format(item.dealerPrice / 100)}</strike></Typography>
                        <Typography className={classes.youSave}>You save: <span className={classes.youSaveValue}>
                        ${new Intl.NumberFormat().format(props.youSave)}</span></Typography>
                    </Box> : null}
                </Grid>
            </Grid>

            </div>
        </>
    );
}
